/**
 * File : 文件
 *

 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/smsg/v1/{organizationId}',
  items: [
    /**
     * 获取列表
     */

    { key: 'getEmail', url: '/email/servers', method: 'GET' },
    { key: 'addEmail', url: '/email/servers', method: 'POST' },
    { key: 'updateEmail', url: '/email/servers', method: 'PUT' },
    { key: 'deleteEmail', url: '/email/servers', method: 'DELETE' },
    // 查询邮箱服务明细
    { key: 'detailEmail', url: '/email/servers/{serverId}', method: 'Get' },
    {
      key: 'detailEmailConfig',
      url: '/email/servers/{serverId}/properties',
      method: 'Get',
    },
    // Email Filter : 邮箱账户黑白名单
    { key: 'getEmailFilters', url: '/email-filters', method: 'GET' },
    { key: 'addEmailFilters', url: '/email-filters', method: 'POST' },
    { key: 'updateEmailFilters', url: '/email-filters', method: 'POST' },
    { key: 'deleteEmailFilters', url: '/email-filters', method: 'DELETE' },
  ],
};

export default {
  ...generate(config),
};
